// components/tickets/TicketPreviewSkeletonSimple.tsx
import React from "react";
import { Loader2 } from "lucide-react";

export default function TicketPreviewSkeletonSimple() {
  return (
    <section className="bg-gradient-to-b from-[#F5F3F0] to-white flex items-center justify-center py-16 px-6">
      <div className="max-w-5xl w-full bg-white/95 backdrop-blur-md border-4 border-[#B9A68D] shadow-2xl p-10 text-center">
        <Loader2 className="mx-auto h-16 w-16 text-[#4E5C36] mb-6 animate-spin" />
        <h2 className="text-2xl font-serif text-[#4E5C36] mb-2">
          Loading Your Ticket...
        </h2>
        <p className="text-gray-600">Preparing your ticket for display.</p>
      </div>
    </section>
  );
}
